import { createFileRoute, retainSearchParams } from "@tanstack/react-router"
import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { ChangeLogCategory, ChangeLogSortField, ChangeLogSubCategory, SortingOrder } from "@/graphql/codegen/graphql"
import ChangeLogContainer from "@/screens/ChangeLog/containers/ChangeLogContainer"

const SearchParamsValidator = z.object({
  query: fallback(z.string().optional().default(""), ""),
  field: fallback(z.nativeEnum(ChangeLogSortField), ChangeLogSortField.CreatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),

  start: z.string().optional(),
  end: z.string().optional(),
  userIds: z.array(z.string()).optional(),
  categories: z.array(z.nativeEnum(ChangeLogCategory)).optional(),
  subcategories: z.array(z.nativeEnum(ChangeLogSubCategory)).optional(),
})

export const Route = createFileRoute("/app/admin/change-log/")({
  validateSearch: SearchParamsValidator,
  search: {
    middlewares: [
      retainSearchParams(["field", "order", "query", "userIds", "subcategories", "categories", "start", "end"]),
    ],
  },
  component: () => {
    return (
      <PermissionContentWrapper permissions={[PermissionActionType.CHANGE_LOG_VIEW]}>
        <ChangeLogContainer />
      </PermissionContentWrapper>
    )
  },
})
